export function animationEvents() {
	const mql = window.matchMedia("(min-width: 1200px)");
	async function onQueryChange(e) {
		if (!e.matches) return;
		mql.removeEventListener("change", onQueryChange);
		try {
			const { initAnimations } = await import("./animations.js");
			initAnimations({ reverse: true });
		} catch (err) {
			console.error("Error loading animations module:", err);
		}
	}
	mql.addEventListener("change", onQueryChange);
	onQueryChange(mql);
}
